import DocumentTitle from "react-document-title";
import { Navigate, Route, Routes } from "react-router-dom";

import PageLayout from "components/layout/Layout";
import { Login } from "components/login/Login";
import { Brands } from "components/brands/Brands";
import { UserLookup } from "components/user-lookup/UserLookup";
import { Blacklist } from "components/blacklist/Blacklist";
import { FraudRisk } from "components/fraud-risk/FraudRisk";
import { AutomatedPaymentBatches } from "components/automated-payments/AutomatedPaymentBatches";

import { RequireAuth } from "contexts/AuthContext";
import { NewBrandForm } from "components/NewBrandForm";
import { BrandWrapper } from "components/brand/Brand";
import { BrandLoginRedirect } from "components/brand/BrandLoginRedirect";

import "App.scss";

const App = () => (
    <Routes>
        <Route
            element={
                <RequireAuth>
                    <PageLayout />
                </RequireAuth>
            }>
            <Route path="brands">
                <Route
                    index
                    element={
                        <DocumentTitle title="Brands | Roster Administration Portal">
                            <Brands />
                        </DocumentTitle>
                    }
                />
                <Route
                    path=":userId/login"
                    element={<BrandLoginRedirect />}
                />
                <Route path=":userId" element={<BrandWrapper />}>
                    <Route path=":tabId" element={<></>} />
                </Route>
            </Route>
            <Route
                path="user-lookup"
                element={
                    <DocumentTitle title="User Lookup | Roster Administration Portal">
                        <UserLookup />
                    </DocumentTitle>
                }
            />
            <Route
                path="new"
                element={
                    <DocumentTitle title="Add New Brand | Roster Administration Portal">
                        <NewBrandForm />
                    </DocumentTitle>
                }
            />
            <Route
                path="automated-payments"
                element={
                    <DocumentTitle title="Payment Batches | Roster Administration Portal">
                        <AutomatedPaymentBatches />
                    </DocumentTitle>
                }
            />
            <Route
                path="fraud-risk"
                element={
                    <DocumentTitle title="Fraud Risk | Roster Administration Portal">
                        <FraudRisk />
                    </DocumentTitle>
                }
            />
            <Route
                path="blacklist"
                element={
                    <DocumentTitle title="Blacklist | Roster Administration Portal">
                        <Blacklist />
                    </DocumentTitle>
                }
            />
            <Route path="*" element={<Navigate to="brands" replace={true} />} />
        </Route>
        <Route path="login" element={<Login />} />
    </Routes>
);

export default App;
